import React from "react";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import { useModal } from "../hooks/useModal";
import { Input } from "rizzui/input";
import { inputClassName, labelClassName } from "../modules/projects/new/first";
import { useForm } from "react-hook-form";

export default function UseCoupon() {
  const { closeModal } = useModal();

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    getValues,
    watch,
  } = useForm({});

  const handleFund = handleSubmit((data) => {
    console.log(data);
    closeModal();
  });
  return (
    <div className="w-[96%] md:w-[402px] mx-auto bg-background dark:bg-[#2A2C30] p-[32px] rounded-[8px] shadow-lg">
      <button
        className="absolute top-4 right-4 p-1 rounded-lg z-10 text-gray-400 bg-transparent hover:text-gray-600 dark:hover:text-gray-300"
        onClick={closeModal}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="size-[18px]"
        >
          <path
            fillRule="evenodd"
            d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <div className="flex flex-col gap-[28px] ">
        <Text className="font-ibmPlexSerif font-[600] text-[18px] text-primary-dark">
          Apply coupon
        </Text>
        <form
          className="flex flex-col gap-[28px] "
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            handleFund();
          }}
        >
          <Input
            label="Coupon code"
            type="text"
            inputClassName={inputClassName}
            labelClassName={labelClassName}
            {...register("code", { required: "Required" })}
            error={errors?.code ? "Required" : ""}
          />

          <ActionIcon
            className="w-full h-[35px] rounded-[4px] !bg-btn"
            type="submit"
          >
            <Text className="font-[400] text-[12px] text-background font-switzer">
              Apply coupon
            </Text>
          </ActionIcon>
        </form>
      </div>
    </div>
  );
}
